import history from '_history'
import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'
import 'react-hot-loader'

import './shared/styles/base.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import theme from '@gameday/react-components/utils/theme'
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { ThemeProvider } from 'styled-components'

import config from './constants/config'
import App_ from './containers/App'
import rootReducer from './reducers'
import rootSaga from './sagas'

// Font awesome initialisation
library.add(faCheckCircle)

const composeEnhancers =
  config.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose
const sagaMiddleware = createSagaMiddleware()
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)))
sagaMiddleware.run(rootSaga)

// Universal Google Analytics - Expires 2023 July
if (config.NODE_ENV === 'production') {
  ReactGA.initialize('UA-113640816-4')
  history.listen(location => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  })
}

// Google Analytics 4
try {
  // biome-ignore lint/complexity/useOptionalChain: TODO
  if (window.location.href && window.location.href.includes('#/event')) {
    if (window.location.href.includes('#/event/registration-form')) {
      if (!config.GA4_EVENT_REGO_FORM_KEY) {
        throw new Error('Unable to fetch Google Analytics 4 Key for Event Registration Form')
      }
      ReactGA4.initialize(config.GA4_EVENT_REGO_FORM_KEY)
    } else {
      if (!config.GA4_EVENT_FORM_KEY) {
        throw new Error('Unable to fetch Google Analytics 4 Key for Event Landing Page')
      }
      ReactGA4.initialize(config.GA4_EVENT_FORM_KEY)
    }
  } else {
    let formKey = config.GA4_REGO_FORM_KEY
    if (window.location.href.includes('shopform')) {
      // Form type is Shop
      if (!config.GA4_SHOP_FORM_KEY) {
        throw new Error('Unable to fetch Google Analytics 4 Key for Shop Form')
      }
      formKey = config.GA4_SHOP_FORM_KEY
    } else {
      // Form type is Rego Form
      if (!config.GA4_REGO_FORM_KEY) {
        throw new Error('Unable to fetch Google Analytics 4 Key for Rego Form')
      }
      formKey = config.GA4_REGO_FORM_KEY
    }
    ReactGA4.initialize(formKey)
  }
  history.listen(location => {
    ReactGA4.set({ page: location.pathname })
    ReactGA4.send('pageview')
  })
} catch (err) {
  // eslint-disable-next-line no-console
  console.error(err)
}

const container = document.getElementById('eventPage')
const root = createRoot(container)

root.render(
  <StylesProvider injectFirst>
    <ThemeProvider theme={theme}>
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <Router history={history}>
            <App_ />
          </Router>
        </Provider>
      </MuiThemeProvider>
    </ThemeProvider>
  </StylesProvider>
)
